/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    acptNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    acptDtlNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    linkAcptNo?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    orderConfirmContents?: JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContent;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    tel?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    businessHourTitle1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    businessHour1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    businessHourTitle2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse
     */
    businessHour2?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acptNo': !exists(json, 'acptNo') ? undefined : json['acptNo'],
        'acptDtlNo': !exists(json, 'acptDtlNo') ? undefined : json['acptDtlNo'],
        'linkAcptNo': !exists(json, 'linkAcptNo') ? undefined : json['linkAcptNo'],
        'orderConfirmContents': !exists(json, 'orderConfirmContents') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentFromJSON(json['orderConfirmContents']),
        'tel': !exists(json, 'tel') ? undefined : json['tel'],
        'businessHourTitle1': !exists(json, 'businessHourTitle1') ? undefined : json['businessHourTitle1'],
        'businessHour1': !exists(json, 'businessHour1') ? undefined : json['businessHour1'],
        'businessHourTitle2': !exists(json, 'businessHourTitle2') ? undefined : json['businessHourTitle2'],
        'businessHour2': !exists(json, 'businessHour2') ? undefined : json['businessHour2'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acptNo': value.acptNo,
        'acptDtlNo': value.acptDtlNo,
        'linkAcptNo': value.linkAcptNo,
        'orderConfirmContents': JpCoBenefitoneBsdpBffPresentationResponseConfirmPayPostResponseOrderConfirmContentToJSON(value.orderConfirmContents),
        'tel': value.tel,
        'businessHourTitle1': value.businessHourTitle1,
        'businessHour1': value.businessHour1,
        'businessHourTitle2': value.businessHourTitle2,
        'businessHour2': value.businessHour2,
    };
}

